import { useEffect, useRef } from 'react';

export type Download = (fileName: string, fileUrl: string) => Promise<void>;

export const useDownload = (): Download => {
  const anchorRef = useRef<HTMLAnchorElement>();

  useEffect(() => {
    const anchorElement = document.createElement('a');
    anchorElement.style.display = 'none';
    document.body.appendChild(anchorElement);
    anchorRef.current = anchorElement;

    return () => {
      document.body.removeChild(anchorElement);
    };
  }, []);

  return async (fileName: string, fileUrl: string): Promise<void> => {
    const anchor = anchorRef.current;
    if (!anchor) {
      return;
    }

    anchor.href = fileUrl;
    anchor.download = fileName;
    anchor.click();
    window.URL.revokeObjectURL(fileUrl);
  };
};
